import { getPrettyRoomTag, getRoomTag } from '../../../../../../modules/room-tag-storage';

export async function initRoomHighlights() {
  // init highlights of part facilities
  const $highlights = $('#js-tag-specific-highlights');
  if (!$highlights.length) {
    return;
  }

  const settings = $highlights.data('settings');

  $highlights[0].outerHTML = $highlights.html();

  $('.js-tag-name').text(await getPrettyRoomTag());

  let visibleHighlights = 0;

  settings.forEach(category => {
    if (category.tags.includes(getRoomTag())) {
      category.items.forEach((item, index) => {
        const $node = $('.c-sp-features-highlights__items')
          .find(`[data-id="${item}"]`);

        const available = $node.data('available');

        if (available) {
          $node.css('order', index);
        } else {
          $node.css('order', index + 100);
        }

        $node.show();
        if (available) {
          visibleHighlights += 1;
        }
      });
    }
  });

  if (visibleHighlights >= 2) {
    $('.c-sp-features-highlights').show();
  }
}
